import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminCompanyDetail } from "@/types/company"

export type AdminCompanyDetailState = {
  data: AdminCompanyDetail | null
  error: string | null
}

export const adminCompanyDetailInitialState: AdminCompanyDetailState = {
  data: null,
  error: null,
}

const slice = createSlice({
  name: "adminCompanyDetail",
  initialState: adminCompanyDetailInitialState,
  reducers: {
    setAdminCompanyDetailAction(state, { payload }: PayloadAction<AdminCompanyDetail | null>) {
      state.data = payload
      state.error = null
    },
    setAdminCompanyDetailErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const { setAdminCompanyDetailAction, setAdminCompanyDetailErrorAction } = slice.actions
export default slice.reducer
